'use client';

import { BRAND } from '@/lib/cms/config';
import { devWarn } from '@/lib/utils/devLog';
import clsx from 'clsx';
import styles from './Icon.module.scss';

// ============================================================================
// GALLET Icons (default)
// ============================================================================
import GalletArrowDown from './icons/brands/gallet/arrow_down.svg';
import GalletArrowLeft from './icons/brands/gallet/arrow_left.svg';
import GalletArrowLongRight from './icons/brands/gallet/arrow_long_right.svg';
import GalletArrowRight from './icons/brands/gallet/arrow_right.svg';
import GalletArrowUp from './icons/brands/gallet/arrow_up.svg';
import GalletAudioOff from './icons/brands/gallet/audio_off.svg';
import GalletAudioOn from './icons/brands/gallet/audio_on.svg';
import GalletBack from './icons/brands/gallet/back.svg';
import GalletBin from './icons/brands/gallet/bin.svg';
import GalletCheck from './icons/brands/gallet/check.svg';
import GalletChevronDown from './icons/brands/gallet/chevron_down.svg';
import GalletChevronLeft from './icons/brands/gallet/chevron_left.svg';
import GalletChevronRight from './icons/brands/gallet/chevron_right.svg';
import GalletChevronUp from './icons/brands/gallet/chevron_up.svg';
import GalletClose from './icons/brands/gallet/close.svg';
import GalletDownload from './icons/brands/gallet/download.svg';
import GalletEarth from './icons/brands/gallet/earth.svg';
import GalletEnlarge from './icons/brands/gallet/enlarge.svg';
import GalletFacebook from './icons/brands/gallet/facebook.svg';
import GalletGift from './icons/brands/gallet/gift.svg';
import GalletGlobe from './icons/brands/gallet/globe.svg';
import GalletGrid from './icons/brands/gallet/grid.svg';
import GalletHeartFilled from './icons/brands/gallet/heart_filled.svg';
import GalletHeartOutline from './icons/brands/gallet/heart_outline.svg';
import GalletInfo from './icons/brands/gallet/info.svg';
import GalletInfoFilled from './icons/brands/gallet/info_filled.svg';
import GalletInstagram from './icons/brands/gallet/instagram.svg';
import GalletLinkedin from './icons/brands/gallet/linkedin.svg';
import GalletLocation from './icons/brands/gallet/location.svg';
import GalletMenu from './icons/brands/gallet/menu.svg';
import GalletPause from './icons/brands/gallet/pause.svg';
import GalletPhone from './icons/brands/gallet/phone.svg';
import GalletPin from './icons/brands/gallet/pin.svg';
import GalletPinterest from './icons/brands/gallet/pinterest.svg';
import GalletPlay from './icons/brands/gallet/play.svg';
import GalletPlus from './icons/brands/gallet/plus.svg';
import GalletPrint from './icons/brands/gallet/print.svg';
import GalletSearch from './icons/brands/gallet/search.svg';
import GalletShare from './icons/brands/gallet/share.svg';
import GalletShoppingBag from './icons/brands/gallet/shopping_bag.svg';
import GalletStar from './icons/brands/gallet/star.svg';
import GalletStrava from './icons/brands/gallet/strava.svg';
import GalletTiktok from './icons/brands/gallet/tiktok.svg';
import GalletTwitter from './icons/brands/gallet/twitter.svg';
import GalletUser from './icons/brands/gallet/user.svg';
import GalletRuler from './icons/brands/gallet/ruler.svg';
import GalletWatch from './icons/brands/gallet/watch.svg';
import GalletSpinner from './icons/brands/gallet/spinner.svg';
import GalletYoutube from './icons/brands/gallet/youtube.svg';

// My Account Icons (Gallet)
import GalletAddresses from './icons/brands/gallet/my_account/addresses.svg';
import GalletMyOrders from './icons/brands/gallet/my_account/my_orders.svg';
import GalletMyPreferences from './icons/brands/gallet/my_account/my_preferences.svg';
import GalletMyWatches from './icons/brands/gallet/my_account/my_watches.svg';
import GalletUserNew from './icons/brands/gallet/my_account/user_new.svg';

// ============================================================================
// BREITLING Icons
// ============================================================================
import BreitlingArrowDown from './icons/brands/breitling/arrow_down.svg';
import BreitlingArrowLeft from './icons/brands/breitling/arrow_left.svg';
import BreitlingArrowLongRight from './icons/brands/breitling/arrow_long_right.svg';
import BreitlingArrowRight from './icons/brands/breitling/arrow_right.svg';
import BreitlingArrowUp from './icons/brands/breitling/arrow_up.svg';
import BreitlingAudioOff from './icons/brands/breitling/audio_off.svg';
import BreitlingAudioOn from './icons/brands/breitling/audio_on.svg';
import BreitlingBack from './icons/brands/breitling/back.svg';
import BreitlingBin from './icons/brands/breitling/bin.svg';
import BreitlingCheck from './icons/brands/breitling/check.svg';
import BreitlingChevronDown from './icons/brands/breitling/chevron_down.svg';
import BreitlingChevronLeft from './icons/brands/breitling/chevron_left.svg';
import BreitlingChevronRight from './icons/brands/breitling/chevron_right.svg';
import BreitlingChevronUp from './icons/brands/breitling/chevron_up.svg';
import BreitlingClose from './icons/brands/breitling/close.svg';
import BreitlingDownload from './icons/brands/breitling/download.svg';
import BreitlingEarth from './icons/brands/breitling/earth.svg';
import BreitlingEnlarge from './icons/brands/breitling/enlarge.svg';
import BreitlingFacebook from './icons/brands/breitling/facebook.svg';
import BreitlingGift from './icons/brands/breitling/gift.svg';
import BreitlingGlobe from './icons/brands/breitling/globe.svg';
import BreitlingGrid from './icons/brands/breitling/grid.svg';
import BreitlingHeartFilled from './icons/brands/breitling/heart_filled.svg';
import BreitlingHeartOutline from './icons/brands/breitling/heart_outline.svg';
import BreitlingInfo from './icons/brands/breitling/info.svg';
import BreitlingInfoFilled from './icons/brands/breitling/info_filled.svg';
import BreitlingInstagram from './icons/brands/breitling/instagram.svg';
import BreitlingLinkedin from './icons/brands/breitling/linkedin.svg';
import BreitlingLocation from './icons/brands/breitling/location.svg';
import BreitlingMenu from './icons/brands/breitling/menu.svg';
import BreitlingPause from './icons/brands/breitling/pause.svg';
import BreitlingPhone from './icons/brands/breitling/phone.svg';
import BreitlingPin from './icons/brands/breitling/pin.svg';
import BreitlingPinterest from './icons/brands/breitling/pinterest.svg';
import BreitlingPlay from './icons/brands/breitling/play.svg';
import BreitlingPlus from './icons/brands/breitling/plus.svg';
import BreitlingPrint from './icons/brands/breitling/print.svg';
import BreitlingPushpin from './icons/brands/breitling/pushpin.svg';
import BreitlingSearch from './icons/brands/breitling/search.svg';
import BreitlingSearchFilled from './icons/brands/breitling/search_filled.svg';
import BreitlingShare from './icons/brands/breitling/share.svg';
import BreitlingShoppingBag from './icons/brands/breitling/shopping_bag.svg';
import BreitlingShoppingBagFilled from './icons/brands/breitling/shopping_bag_filled.svg';
import BreitlingSpinner from './icons/brands/breitling/spinner.svg';
import BreitlingStar from './icons/brands/breitling/star.svg';
import BreitlingStrava from './icons/brands/breitling/strava.svg';
import BreitlingTiktok from './icons/brands/breitling/tiktok.svg';
import BreitlingTwitter from './icons/brands/breitling/twitter.svg';
import BreitlingUser from './icons/brands/breitling/user.svg';
import BreitlingUserFilled from './icons/brands/breitling/user_filled.svg';
import BreitlingRuler from './icons/brands/breitling/ruler.svg';
import BreitlingWatch from './icons/brands/breitling/watch.svg';
import BreitlingYoutube from './icons/brands/breitling/youtube.svg';

// My Account Icons (Breitling only)
import BreitlingAddresses from './icons/brands/breitling/my_account/addresses.svg';
import BreitlingAddressesActive from './icons/brands/breitling/my_account/addresses_active.svg';
import BreitlingLogout from './icons/brands/breitling/my_account/logout.svg';
import BreitlingMyDetails from './icons/brands/breitling/my_account/my_details.svg';
import BreitlingMyDetailsActive from './icons/brands/breitling/my_account/my_details_active.svg';
import BreitlingMyFavorite from './icons/brands/breitling/my_account/my_favorite.svg';
import BreitlingMyFavoriteActive from './icons/brands/breitling/my_account/my_favorite_active.svg';
import BreitlingMyPreferences from './icons/brands/breitling/my_account/my_preferences.svg';
import BreitlingMyPreferencesActive from './icons/brands/breitling/my_account/my_preferences_active.svg';

/**
 * Icon names - all available icons
 */
export type IconName =
  // Core Icons
  | 'arrow-right'
  | 'arrow-left'
  | 'arrow-long-right'
  | 'arrow-down'
  | 'arrow-up'
  | 'check'
  | 'audio-off'
  | 'audio-on'
  | 'back'
  | 'bin'
  | 'close'
  | 'earth'
  | 'enlarge'
  | 'grid'
  | 'heart-filled'
  | 'heart-outline'
  | 'pause'
  | 'pin'
  | 'pushpin'
  | 'play'
  | 'search'
  | 'search-filled'
  | 'shopping-bag'
  | 'shopping-bag-filled'
  | 'spinner'
  | 'star'
  | 'user'
  | 'user-filled'
  | 'watch'
  | 'print'
  | 'plus'
  // Navigation Icons
  | 'menu'
  | 'chevron-right'
  | 'chevron-left'
  | 'chevron-down'
  | 'chevron-up'
  | 'share'
  | 'gift'
  | 'download'
  // Social Icons
  | 'facebook'
  | 'youtube'
  | 'instagram'
  | 'linkedin'
  | 'pinterest'
  | 'twitter'
  | 'strava'
  | 'tiktok'
  // Additional Utility Icons
  | 'globe'
  | 'info'
  | 'info-filled'
  | 'location'
  | 'phone'
  | 'ruler'
  // My Account Icons
  | 'my-details'
  | 'my-details-active'
  | 'addresses'
  | 'addresses-active'
  | 'my-preferences'
  | 'my-preferences-active'
  | 'my-orders'
  | 'my-watches'
  | 'user-new'
  | 'my-favorite'
  | 'my-favorite-active'
  | 'logout';

// Gallet icon components map
const galletIconComponents: Record<IconName, React.ComponentType<React.SVGProps<SVGSVGElement>>> = {
  'arrow-right': GalletArrowRight,
  'arrow-left': GalletArrowLeft,
  'arrow-long-right': GalletArrowLongRight,
  'arrow-down': GalletArrowDown,
  'arrow-up': GalletArrowUp,
  check: GalletCheck,
  'audio-off': GalletAudioOff,
  'audio-on': GalletAudioOn,
  back: GalletBack,
  bin: GalletBin,
  close: GalletClose,
  earth: GalletEarth,
  enlarge: GalletEnlarge,
  grid: GalletGrid,
  'heart-filled': GalletHeartFilled,
  'heart-outline': GalletHeartOutline,
  info: GalletInfo,
  'info-filled': GalletInfoFilled,
  pause: GalletPause,
  pin: GalletPin,
  pushpin: GalletPin,
  play: GalletPlay,
  search: GalletSearch,
  'search-filled': GalletSearch,
  'shopping-bag': GalletShoppingBag,
  'shopping-bag-filled': GalletShoppingBag,
  spinner: GalletSpinner,
  star: GalletStar,
  user: GalletUser,
  'user-filled': GalletUser,
  watch: GalletWatch,
  print: GalletPrint,
  menu: GalletMenu,
  'chevron-right': GalletChevronRight,
  'chevron-left': GalletChevronLeft,
  'chevron-down': GalletChevronDown,
  'chevron-up': GalletChevronUp,
  share: GalletShare,
  gift: GalletGift,
  download: GalletDownload,
  facebook: GalletFacebook,
  youtube: GalletYoutube,
  instagram: GalletInstagram,
  linkedin: GalletLinkedin,
  pinterest: GalletPinterest,
  twitter: GalletTwitter,
  strava: GalletStrava,
  tiktok: GalletTiktok,
  globe: GalletGlobe,
  location: GalletLocation,
  phone: GalletPhone,
  ruler: GalletRuler,
  // My Account Icons
  'my-details': GalletUser,
  'my-details-active': GalletUser,
  addresses: GalletAddresses,
  'addresses-active': GalletAddresses,
  'my-preferences': GalletMyPreferences,
  'my-preferences-active': GalletMyPreferences,
  'my-orders': GalletMyOrders,
  'my-watches': GalletMyWatches,
  'user-new': GalletUserNew,
  'my-favorite': GalletHeartOutline,
  'my-favorite-active': GalletHeartFilled,
  logout: GalletUser,
  plus: GalletPlus,
};

// Breitling icon components map
const breitlingIconComponents: Record<
  IconName,
  React.ComponentType<React.SVGProps<SVGSVGElement>>
> = {
  'arrow-right': BreitlingArrowRight,
  'arrow-left': BreitlingArrowLeft,
  'arrow-long-right': BreitlingArrowLongRight,
  'arrow-down': BreitlingArrowDown,
  'arrow-up': BreitlingArrowUp,
  check: BreitlingCheck,
  'audio-off': BreitlingAudioOff,
  'audio-on': BreitlingAudioOn,
  back: BreitlingBack,
  bin: BreitlingBin,
  close: BreitlingClose,
  earth: BreitlingEarth,
  enlarge: BreitlingEnlarge,
  grid: BreitlingGrid,
  'heart-filled': BreitlingHeartFilled,
  'heart-outline': BreitlingHeartOutline,
  info: BreitlingInfo,
  'info-filled': BreitlingInfoFilled,
  pause: BreitlingPause,
  pin: BreitlingPin,
  pushpin: BreitlingPushpin,
  play: BreitlingPlay,
  search: BreitlingSearch,
  'search-filled': BreitlingSearchFilled,
  'shopping-bag': BreitlingShoppingBag,
  'shopping-bag-filled': BreitlingShoppingBagFilled,
  spinner: BreitlingSpinner,
  star: BreitlingStar,
  user: BreitlingUser,
  'user-filled': BreitlingUserFilled,
  watch: BreitlingWatch,
  print: BreitlingPrint,
  menu: BreitlingMenu,
  'chevron-right': BreitlingChevronRight,
  'chevron-left': BreitlingChevronLeft,
  'chevron-down': BreitlingChevronDown,
  'chevron-up': BreitlingChevronUp,
  share: BreitlingShare,
  gift: BreitlingGift,
  download: BreitlingDownload,
  facebook: BreitlingFacebook,
  youtube: BreitlingYoutube,
  instagram: BreitlingInstagram,
  linkedin: BreitlingLinkedin,
  pinterest: BreitlingPinterest,
  twitter: BreitlingTwitter,
  strava: BreitlingStrava,
  tiktok: BreitlingTiktok,
  globe: BreitlingGlobe,
  location: BreitlingLocation,
  phone: BreitlingPhone,
  ruler: BreitlingRuler,
  // My Account Icons
  'my-details': BreitlingMyDetails,
  'my-details-active': BreitlingMyDetailsActive,
  addresses: BreitlingAddresses,
  'addresses-active': BreitlingAddressesActive,
  'my-preferences': BreitlingMyPreferences,
  'my-preferences-active': BreitlingMyPreferencesActive,
  'my-orders': BreitlingShoppingBag,
  'my-watches': BreitlingWatch,
  'user-new': BreitlingUser,
  'my-favorite': BreitlingMyFavorite,
  'my-favorite-active': BreitlingMyFavoriteActive,
  logout: BreitlingLogout,
  plus: BreitlingPlus,
};

// Select icon set based on brand
const iconComponents = BRAND === 'breitling' ? breitlingIconComponents : galletIconComponents;

export interface IconProps {
  /** Icon name from the design system */
  name: IconName;
  /** Size in pixels (default: 24) */
  size?: number;
  /** Additional className */
  className?: string;
  /** Accessible label (for standalone icons) */
  'aria-label'?: string;
}

/**
 * Icon component - uses brand-specific SVG files via SVGR
 * Renders inline SVGs that support currentColor for theming.
 * Automatically selects the correct icon set based on the BRAND environment variable.
 */
export function Icon({ name, size = 24, className, 'aria-label': ariaLabel }: IconProps) {
  const SvgComponent = iconComponents[name];

  if (!SvgComponent) {
    devWarn(`Icon "${name}" not found for brand "${BRAND}"`);
    return null;
  }

  return (
    <SvgComponent
      className={clsx(styles.icon, className)}
      width={size}
      height={size}
      aria-hidden={!ariaLabel}
      aria-label={ariaLabel}
      role={ariaLabel ? 'img' : undefined}
    />
  );
}

Icon.displayName = 'Icon';
